<template>
  <div>
    <h4 class="m-4">Live Ad Review</h4>
    <div class="m-4 d-flex">
      <div>
        <date-picker :date="date" :timezone="timezone" @timeZoneChange="timezone = $event"></date-picker>
      </div>
      <div class="ml-auto">
        <b-form inline>
          <b-input v-model="filterBidCid" class="mx-1" placeholder="Campaign ID"></b-input>
          <b-input v-model="filterBidCrid" class="mx-1" placeholder="Creative ID"></b-input>
          <b-btn @click="getLiveAds" class="mx-1" variant="primary">Search</b-btn>
        </b-form>
      </div>
    </div>
    <report-table
      v-if="!(!loading && liveAds.results.length === 0)"
      :report="liveAds.results"
      :stats="liveAds.stats"
      :fields="liveAds.fields"
      :showChevrons="false"
      :slots="['Sample Preview', 'Live Preview', {key: 'details_button', label: ' '}]">
      <template slot="details_button" slot-scope="data">
        <template v-if="data.item.bidder_id && data.item.bid_cid && data.item.bid_crid">
          <b-btn :to="{ name: 'AdminAdDetails',
          params: { partnerId: data.item.demand_partner_id, cid: data.item.bid_cid, crid: data.item.bid_crid },
          query: { start: date.start, end: date.end }}"
                 variant="light" size="sm">
            View Details
          </b-btn>
        </template>
      </template>
      <template slot="Live Preview" slot-scope="data">
        <b-card no-body class="p-1 d-inline-block" bg-variant="lighter">
          <live-ad-preview width="100px" height="100px"
                           :key="getPreviewKey(data.item.bidder_id, data.item.bid_cid, data.item.bid_crid)"
                           :partner="data.item.bidder_name" :cid="data.item.bid_cid"
                           :crid="data.item.bid_crid"></live-ad-preview>
        </b-card>
      </template>
    </report-table>
    <no-results v-else></no-results>
  </div>
</template>

<script>
    import {ReportsApi} from '@/reports/api'
    import DatePicker from '@/components/DatePicker'
    import ReportTable from '@/reports/components/ReportTable'
    import SampleAdPreview from '@/components/preview/SampleAdPreview'
    import LiveAdPreview from '@/components/preview/LiveAdPreview'
    import NoResults from '@/components/NoResults'
    import {getDefaultPriceField} from '@/reports/components/ReportUtils'

    import auth from '@/auth'

    export default {
        props: {
            cid: {type: String, required: false}
        },
        created() {
            this.liveAds.stats.push(getDefaultPriceField())
            this.getLiveAds()
        },
        data() {
            return {
                liveAds: {
                    fields: ['bidder_name','bid_cid', 'bid_crid'],
                    stats: ['bids', 'clears'],
                    results: [],
                },
                filterBidCid: '',
                filterBidCrid: '',
                timezone: 'UTC',
                date: {
                    start: moment().utc().startOf('day').valueOf(),
                    end: moment().utc().endOf('day').valueOf()
                },
                loading: true
            }
        },
        methods: {
            getPreviewKey(partner, cid, crid) {
                return partner + cid + crid
            },
            getLiveAds() {
                this.loading = true
                return ReportsApi.bqreport(this.liveAdQuery, this).then((data) => {
                    this.liveAds.results = data.results
                }, (e) => {
                    console.error(e)
                }).finally(() => {
                    this.loading = false
                })
            },
            companyId() {
                if (this.cid) {
                    return this.cid
                }
                if (auth.isAdmin()) {
                    return null /* report for all */
                }

                return auth.company().company_id
            }
        },
        computed: {
            type() {
                return auth.getType()
            },
            liveAdQuery() {
                let query = {
                    dateAsMillis: true,
                    startTime: this.date.start,
                    endTime: this.date.end,
                    fields: this.liveAds.fields,
                    filters: [{
                        field: 'bid_adm',
                        operator: 'NOT_NULL'
                    }],
                    stats: this.liveAds.stats,
                    timezone: 'UTC',
                    limit: 5
                }
                let mode = this.$route.path.split("/")[1]
                if (mode === 'publisher') {
                    query.filters.push({field: 'exchange_id', operator: 'EQUAL', value: 'smartrtb'})
                    query.filters.push({field: 'pub_id', operator: 'EQUAL', value: this.companyId()})
                }
                if (mode === 'demand') {
                    query.filters.push({field: 'bidder_id', operator: 'EQUAL', value: this.companyId()})
                }
                if (mode === 'exchange') {
                    query.filters.push({field: 'exchange_id', operator: 'CONTAINS', value: this.companyId()})
                }
                return query
            }
        },
        watch: {
            date: {
                deep: true,
                handler: function () {
                    this.getLiveAds()
                }
            }
        },
        components: {
            DatePicker,
            ReportTable,
            SampleAdPreview,
            LiveAdPreview,
            NoResults
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/pages/AdReview/LiveAds.vue